<template>
    <div>
        <div class="columns">
            <div class="column between-center">
                <h4 class="title is-3 is-marginless is-paddingless no-border">Tracking/IBM #</h4>
                <div class="field is-grouped">
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <button @click="openApplicationModal" class="button is-info" >
                            <span class="icon">
                                <i class="icm-new"></i>
                            </span>
                            <span>New</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <o-table
                    class="is-responsive is-responsive-desktop"
                    :data="trackings"
                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="table.checkable"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort-direction="table.defaultSortDirection"
                    :default-sort="table.defaultSort"

                    :selected.sync="selected"
                    :checked-rows="checkedRows"
                    @update:checkedRows="$event => checkedRows = $event"
                >
                    <template>

                        <o-table-column #default="{ row }" field="type" label="Type" sortable>
                            {{ trackingTypeNameById(row.numeric_type) }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="applicant_id" label="Applicant" sortable>
                            {{ row.applicant_name }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="status" label="Status" sortable>
                            {{ statusNameById(row.status) }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="application_number" label="Application Number" sortable>
                            {{ row.application_number }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="expiration_date" label="Expiration Date" sortable>
                            {{   $filters.valueOrDefault($filters.date(row.expiration_date)) }}
                        </o-table-column>

                        <o-table-column #default="{ row }" label="">
                            <o-dropdown hoverable position="bottom-left" class="table-actions">
                                <template #trigger>
                                    <button class="button">
                                        <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                    </button>
                                </template>
                                <o-dropdown-item has-link><a @click.stop="selectApplication(row)">View</a></o-dropdown-item>
                                <o-dropdown-item has-link><a @click.stop="openApplicationModal(row)">Edit</a></o-dropdown-item>
                                <o-dropdown-item has-link><a @click.stop="$emit('task-create', 'tracking', row.id)">Create Activity</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>
                    </template>

                    <template #empty>
                        <div class="has-text-centered">
                            No Tracking/IBM # entered
                        </div>
                    </template>
                </o-table>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive">
            <application-modal :application="selectedApplication" preselected-type="Tracking"/>
        </o-modal>
    </div>
</template>

<script>
    import ApplicationModal from './../../../../components/modals/applications/Layout'
    import Application from './../../../../mixins/Application'
    import Table from '../../../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [Table, Application],

        components: {
            ApplicationModal
        },

        data() {
            return {
                type: 'tracking'
            }
        },

        methods: {
            ...mapActions({
                removeItem: 'trackings/remove'
            })
        },

        computed: {
            ...mapGetters({
                trackings: 'trackings/currentProjectItems',
                trackingTypeNameById: 'trackingTypeNameById',
            })
        }
    }
</script>
